function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import T from 'prop-types';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import { useAsyncFn } from 'react-use';
import { alertError, alertSuccess, alertWarning } from '../../redux/actions';
import { client } from '../../utilities/api';
import { captureError } from '../../utilities/error';
import { useRedirect } from '../../hooks/useRedirect';
import routes from '../../routes/constants';
var updateRequestAccess = function(projectId, userId, status) {
    return /*#__PURE__*/ _async_to_generator(function() {
        var resp;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        client.updateRequestAccess(projectId, userId, status)
                    ];
                case 1:
                    resp = _state.sent();
                    return [
                        2,
                        resp
                    ];
            }
        });
    });
};
var UpdateBookmarkPage = function(param) {
    var status = param.status;
    var redirect = useRedirect();
    var dispatch = useDispatch();
    var _useParams = useParams(), projectId = _useParams.projectId, _userId = _useParams.userId;
    var userId = _userId ? parseInt(_userId, 10) : null;
    var _useAsyncFn = _sliced_to_array(useAsyncFn(updateRequestAccess(projectId, userId, status), [
        projectId,
        userId,
        status
    ]), 2), state = _useAsyncFn[0], update = _useAsyncFn[1];
    useEffect(function() {
        _async_to_generator(function() {
            var resp, _resp_data_bookmark, _resp_data, redirectUrl;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            update()
                        ];
                    case 1:
                        resp = _state.sent();
                        // was successful
                        if (resp.data) {
                            ;
                            redirectUrl = (_resp_data = resp.data) === null || _resp_data === void 0 ? void 0 : (_resp_data_bookmark = _resp_data.bookmark) === null || _resp_data_bookmark === void 0 ? void 0 : _resp_data_bookmark.redirect_url;
                            if (redirectUrl) {
                                redirect.push(redirectUrl);
                            } else {
                                redirect.push(routes.dashboard);
                            }
                            dispatch(alertSuccess('Access updated successfully'));
                        }
                        return [
                            2
                        ];
                }
            });
        })();
    }, [
        dispatch,
        redirect,
        update
    ]);
    useEffect(function() {
        var err = state.error;
        if (err) {
            var _err_response_data, _err_response;
            if (((_err_response = err.response) === null || _err_response === void 0 ? void 0 : (_err_response_data = _err_response.data) === null || _err_response_data === void 0 ? void 0 : _err_response_data.statusCode) === 409) {
                dispatch(alertWarning(err.response.data.message));
            } else {
                var _err_response_data1, _err_response1;
                var _err_response_data_message;
                dispatch(alertError((_err_response_data_message = (_err_response1 = err.response) === null || _err_response1 === void 0 ? void 0 : (_err_response_data1 = _err_response1.data) === null || _err_response_data1 === void 0 ? void 0 : _err_response_data1.message) !== null && _err_response_data_message !== void 0 ? _err_response_data_message : err.message));
                captureError(err);
            }
        }
    }, [
        dispatch,
        state.error
    ]);
    return null;
};
UpdateBookmarkPage.propTypes = {
    status: T.oneOf([
        'accepted',
        'rejected'
    ])
};
export default UpdateBookmarkPage;
